import type { FaqAnswerBlock, FaqSegment } from '../content/portalFaqData'
import { CLUB4X4_PHONE_TEL } from '../claims/contactLinks'

const answerTextClass = 'font-body font-regular text-md leading-md text-text-tertiary-600'
const linkClass = 'text-foreground-brand-primary-600 underline hover:text-foreground-brand-primary-700'

/** Render one inline FAQ answer segment (text, link, or phone). */
function FaqSegmentContent({ segment }: { segment: FaqSegment }) {
  if (typeof segment === 'string') {
    return <>{segment}</>
  }

  if ('phone' in segment) {
    const display = segment.display ?? segment.phone
    return (
      <a href={CLUB4X4_PHONE_TEL} className={linkClass}>
        {display}
      </a>
    )
  }

  return (
    <a href={segment.href} target="_blank" rel="noopener noreferrer" className={linkClass}>
      {segment.link}
    </a>
  )
}

/** Render structured FAQ answer blocks (paragraphs and bullet lists). */
export default function FaqAnswerContent({ blocks }: { blocks: FaqAnswerBlock[] }) {
  return (
    <div className="flex flex-col gap-[12px]">
      {blocks.map((block, index) => {
        if (block.type === 'paragraph') {
          return (
            <p key={index} className={answerTextClass}>
              {block.segments.map((segment, segmentIndex) => (
                <FaqSegmentContent key={segmentIndex} segment={segment} />
              ))}
            </p>
          )
        }

        return (
          <ul key={index} className={`${answerTextClass} list-disc pl-[20px] flex flex-col gap-[6px]`}>
            {block.items.map((item, itemIndex) => (
              <li key={itemIndex}>
                {item.map((segment, segmentIndex) => (
                  <FaqSegmentContent key={segmentIndex} segment={segment} />
                ))}
              </li>
            ))}
          </ul>
        )
      })}
    </div>
  )
}
